import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";
import IInstallment from "Types/Installment";

export const GET_CHARGES = "[CHARGE] GET_CHARGES";
export const GET_CHARGES_SUCCESS = "[CHARGE] GET_CHARGES_SUCCESS";
export const GET_CHARGES_FAILED = "[CHARGE] GET_CHARGES_FAILED";

export const SET_VALUE = "[CHARGE EDIT] SET_VALUE";
export const CLEAR_VALUES = "[CHARGE EDIT] CLEAR_VALUES";

export function setValue(payload: any) {
	return { type: SET_VALUE, payload };
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function getCharges(
	skip?: number,
	take: number = 10,
	filter?: any[],
	sort?: string,
	desc?: boolean,
	toExport?: boolean,
	callback?: Callback<IInstallment[]>
) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_CHARGES });

		try {
			const { login } = getState();

			const response = await api.sendGet(
				`/Installment?skip=${skip}&take=${take}&sort=${sort}&desc=${desc}${
					filter || "&filters=null"
				}`,
				{
					Authorization: `Bearer ${login.token}`
				}
			);

			const result = await response.json();

			if (result.isValid) {
				if (toExport) {
					dispatch(setValue({ loading: false }));
				} else {
					dispatch({
						type: GET_CHARGES_SUCCESS,
						payload: result.model
					});

					if (result.params)
						dispatch(
							setValue({
								pages: Math.ceil(result.params.count / (take || 10)),
								...result.params
							})
						);
				}

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_CHARGES_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: GET_CHARGES_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
